module.exports = __webpack_public_path__ + "img/icon-shipping-type.95c869ea.svg";